// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_30b","cls2":"SplitVerdictPreviewList-cls2_ZKs SplitVerdictPreviewList-cls1_30b"};